import { safeParse, safeStringify } from 'utils';

export const LOCAL_STORAGE_KEYS = {
  COMPLETED_STEPS: 'resolve-steps',
};

export default {
  ram: {} as Record<string, string>,
  setItem(key: string, value: Record<string, any> | string | boolean) {
    try {
      localStorage.setItem(key, safeStringify(value));
    } catch (e) {
      this.ram[key] = safeStringify(value);
    }
  },
  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      this.ram[key] = undefined;
    }
  },
  getItem<T>(key: string): T {
    const localStorageItem = safeParse(localStorage.getItem(key));

    if (localStorageItem !== undefined) return localStorageItem;

    return safeParse(this.ram[key]);
  },
};
